// Wait for DOM
document.addEventListener("DOMContentLoaded", () => {
  const targetSelector = ".meety-inline-widget"; // parent
  const textSelector = ".meety-alert-text"; // exact child
  const targetSelector2 = ".meety-page";
  // FIXED: both classes on the same element (no space)
  const textSelector2 = ".meety-button.meety-button-primary";

  // -----------------------------
  // 1) BLOCK MEETY'S AUTO-SCROLL
  // -----------------------------

  // Patch Element.prototype.scrollIntoView
  const originalScrollIntoView = Element.prototype.scrollIntoView;
  Element.prototype.scrollIntoView = function (...args) {
    try {
      // If this element is inside Meety widget, block the scroll
      if (
        this.closest(".meety-inline-widget") ||
        this.closest(".meety-page")
      ) {
        // console.log("Blocked scrollIntoView for Meety element", this);
        return; // do nothing
      }
    } catch (e) {
      console.warn("scrollIntoView patch error:", e);
    }

    // For everything else, behave normally
    return originalScrollIntoView.apply(this, args);
  };

  // Patch window.scrollTo and window.scroll
  const originalScrollTo = window.scrollTo.bind(window);
  const originalScroll = window.scroll.bind(window);

  function shouldBlockProgrammaticScroll(args) {
    // You can make this smarter later if needed.
    // For now, block ALL programmatic scrolls to kill Meety's auto-scroll.
    return true;
  }

  window.scrollTo = function (...args) {
    if (shouldBlockProgrammaticScroll(args)) {
      // console.log("Blocked window.scrollTo", args);
      return; // do nothing
    }
    return originalScrollTo(...args);
  };

  window.scroll = function (...args) {
    if (shouldBlockProgrammaticScroll(args)) {
      // console.log("Blocked window.scroll", args);
      return; // do nothing
    }
    return originalScroll(...args);
  };

  // ---------------------------------
  // 2) YOUR EXISTING TRANSLATION CODE
  // ---------------------------------

  function updateText2() {
    const el = document.querySelector(textSelector2);
    if (!el) return;

    const original = el.textContent.trim();
    const match = original.match(/Ajanvaraus uudelleen/);

    if (match) {
      el.textContent = "Siirrä varaus";
    }
  }

  function updateText() {
    const el = document.querySelector(textSelector);
    if (!el) return;

    const original = el.textContent.trim();

    // Match: "<number> välilyöntiä jäljellä"
    const match = original.match(/^(\d+)\s+välilyöntiä jäljellä$/);
    const match2 = original.match(/^(\d+)\s+tilaa jäljellä$/);

    if (match) {
      const n = Number(match[1]);
      el.textContent = n === 1
        ? "1 huolto jäljellä"
        : `${n} huoltoa jäljellä`;
    }

    if (match2) {
      const n = Number(match2[1]);
      el.textContent = n === 1
        ? "1 huolto jäljellä"
        : `${n} huoltoa jäljellä`;
    }
  }

  // Run once in case it's already there
  updateText();
  updateText2();

  // Watch for dynamic changes from Meety
  const parent = document.querySelector(targetSelector);
  const parent2 = document.querySelector(targetSelector2);

  if (parent) {
    const observer = new MutationObserver(() => {
      updateText();
    });

    observer.observe(parent, {
      childList: true,
      subtree: true,
      characterData: true
    });
  } else {
    console.warn("Meety widget parent not found:", targetSelector);
  }

  if (parent2) {
    const observer2 = new MutationObserver(() => {
      updateText2();
    });

    observer2.observe(parent2, {
      childList: true,
      subtree: true,
      characterData: true
    });
  } else {
    console.warn("Meety widget parent not found:", targetSelector2);
  }
});
